import React from "react";

const BoxDiv = (props) => {
  return (
    <div>
      <div
        className="mx-auto"
        style={{
          width: "40px",
          height: "40px",
          backgroundColor: props.topColor || "#F3F3F3",
          marginBottom: "-20px",
          transform: "rotate(45deg)",
        }}
      ></div>
      <div
        className="w-100 p-0 m-0"
        style={{
          backgroundColor: props.bgColor || "white",
          minHeight: props.minHeight ? props.minHeight : "200px",
          borderRadius: "2px",
        }}
      >
        {props.children}
      </div>
    </div>
  );
};

export { BoxDiv };
